import { useTranslation } from "react-i18next";
import { IoIosCall, IoMdMail } from "react-icons/io";
import { IoLocationSharp } from "react-icons/io5";
import { FaFax } from "react-icons/fa";
import image from "../../common/images/all_products.jpeg";

const Contact = () => {
  const { t } = useTranslation(["common"]);
  return (
    <main
      id="contact"
      className="text-gray-900 grid grid-cols-12 container mx-auto px-3 py-10 lg:py-20 gap-6 xl:gap-10"
    >
      <section className="col-span-12 md:col-span-6 flex flex-col items-center justify-center py-10">
        <header className="w-full header">{t("common:contact")}</header>
        <article className="text-lg mt-6 text-center px-10">
          {t("common:contact_text")}
        </article>

        <aside className="flex flex-col mt-5 w-full px-10 space-y-5">
          <div className="group w-full cursor-pointer rounded-lg hover:shadow-xl hover:shadow-gray-200 hover:bg-gray-100 hover:scale-105 duration-500 group flex items-center space-x-4">
            <div className="bg-gray-100 w-14 h-14 flex items-center justify-center rounded-lg flex-shrink-0">
              <IoLocationSharp size={25} />
            </div>
            <div className="">{t("address")}</div>
          </div>
          <div className="group w-full  rounded-lg hover:shadow-xl hover:shadow-gray-200 hover:bg-gray-100 hover:scale-105 duration-500 group flex items-center space-x-4">
            <div className="bg-gray-100 w-14 h-14 flex items-center justify-center rounded-lg">
              <IoIosCall size={25} />
            </div>
            <a href="tel:+99362488800">+99362488800 </a>
            <span>/</span>
            <a href="tel:+99312413633">+99312413633</a>
          </div>
          <div className="group w-full cursor-pointer rounded-lg hover:shadow-xl hover:shadow-gray-200 hover:bg-gray-100 hover:scale-105 duration-500 group flex items-center space-x-4">
            <div className="bg-gray-100 w-14 h-14 flex items-center justify-center rounded-lg">
              <FaFax size={25} />
            </div>
            <div>Fax: +99312413633</div>
          </div>
          <a
            href="mailto:support@sada-suw.tm"
            className="group w-full cursor-pointer rounded-lg hover:shadow-xl hover:shadow-gray-200 hover:bg-gray-100 hover:scale-105 duration-500 group flex items-center space-x-4"
          >
            <div className="bg-gray-100 w-14 h-14 flex items-center justify-center rounded-lg">
              <IoMdMail size={25} />
            </div>
            <div>sada-suw.info@gmail.com</div>
          </a>
        </aside>
      </section>
      <section className="col-span-12 md:col-span-6">
        <img
          src={image}
          alt="product"
          className="h-full w-full object-cover rounded-lg shadow-xl shadow-green-200"
        />
      </section>
    </main>
  );
};

export default Contact;
